<template>
    <div class="reporte">
        <div>
            <div class="asignaciones">
                <div>
                    <h3>Asignaciones administrativas</h3>
                    <div>
                        <label for="">Monitor: </label>
                        <b-select name="" id="" v-model="monitor" @change="saveMonitor">
                            <option v-for="(monitor, index) in monitorList" :key="index" :value="monitor.id">{{monitor.name}}</option>
                        </b-select>
                    </div>
                    <div>
                        <label for="">Administrador: </label>
                        <b-select name="" id="" v-model="admin" @change="saveAdmin">
                            <option v-for="(admin, index) in administradorList" :key="index" :value="admin.id">{{admin.name}}</option>
                        </b-select>
                    </div>
                </div>
            </div>
            <div class="ingresos">
                <div>
                    <h3 for="">Ultimos ingresos</h3>
                    <center>
                        <table>
                            <thead>
                                <tr>
                                    <th>Fecha</th>
                                    <th>Plataforma</th>
                                    <th>Tokens</th>
                                    <th>Dolar</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(ledger, index) in ledgers" :key="index">
                                    <td>{{ledger.date.split($store.state.constants.SEPARETOR)[0]}}</td>
                                    <td>{{ledger.platform}}</td>
                                    <td>{{ledger.tokens}}</td>
                                    <td>{{priceFormat(ledger.dolars)}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </center>
                </div>
            </div>
        </div>
        <div>
            <div class="plataformas">
                <div>
                    <h3>Ingreso plataformas</h3>
                    <div v-for="(platform, index) in platforms" :key="index">
                        <img src="@/assets/plataformas/BongaCams.png" v-if="platform.name === 'Bongacams'" alt="">
                        <img src="@/assets/plataformas/CAM4.png" v-if="platform.name === 'Cam4'" alt="">
                        <img src="@/assets/plataformas/camsoda.png" v-if="platform.name === 'Camsoda'" alt="">
                        <img src="@/assets/plataformas/chaturbate.svg" v-if="platform.name === 'Chaturbate'" alt="">
                        <img src="@/assets/plataformas/Myfreecams.png" v-if="platform.name === 'Myfreecams'" alt="">
                        <img src="@/assets/plataformas/skyprivate.webp" v-if="platform.name === 'Skyprivate'" alt="">
                        <img src="@/assets/plataformas/Stripchat.png" v-if="platform.name === 'Stripchat'" alt="">
                        <label for="">{{platform.balance}}</label>
                        <label for="">{{platform.status === 'enable' ? 'Habilitada' : 'Deshabilitada'}}</label>
                    </div>
                </div>
            </div>
            <div class="generales">
                <div>
                    <h3>General</h3>
                    <div>
                        <div>
                            <label for="">Total tokens <br><br> <span>{{sumTokens}}</span></label>
                        </div>
                        <div>
                            <label for="">Total Dollars <br><br> <span>{{priceFormat(sumPlatform)}}</span></label>
                        </div>
                    </div>
                    <div>
                        <div>
                            <label for="">Mejor plataforma <br><br> <span>{{BestPlatfom.name}}</span></label>
                        </div>
                        <div>
                            <label for="">Puesto <br><br> <span>{{puesto}}</span></label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import API from '@/api'
import Price from '@/utils/ConvertPriceNumber'

export default {
    name: 'reporte',
    data() {
        return {
            monitorList: [],
            administradorList: [],
            monitor: null,
            admin: null,
            ledgers: [],
            platforms: [],
            puesto: 0
        }
    },
    computed: {
        sumPlatform: {
            get() {
                return this.platforms.reduce((accumulator, object) => { return accumulator + object.balance }, 0)
            }
        },
        sumTokens: {
            get() {
                return this.ledgers.reduce((accumulator, object) => { return accumulator + object.tokens }, 0)
            }
        },
        BestPlatfom: {
            get() {
                var mayor = this.platforms[0] !== undefined ? this.platforms[0] : null
                if (!this.platforms[0] !== undefined) {
                    return { name: ' no hay plataforma' }
                }
                this.platforms.forEach(platform => {
                    if (mayor.balance < platform.balance) {
                        mayor = platform
                    }
                })
                return mayor
            }
        }
    },
    methods: {
        priceFormat: function(item) {
            return Price(item)
        },
        getMonitorAndAdmin() {
            API.getMonitorAndAdmin(this.$route.params.model_id)
                .then((res) => {
                    this.monitor = res.monitor
                    this.admin = res.admin
                })
        },
        saveMonitor() {
            API.saveMonitor(this.$route.params.model_id, this.monitor)
                .then((res) => {
                    console.log(res)
                })
        },
        saveAdmin() {
            API.saveAdmin(this.$route.params.model_id, this.admin)
                .then((res) => {
                    console(res)
                })
        },
        getMonitor() {
            API.getMonitorList()
                .then((res) => {
                    this.monitorList = res
                })
        },
        getAdministrador() {
            API.getAdministradorList()
                .then((res) => {
                    this.administradorList = res
                })
        },
        getLedgers() {
            API.getLedgersModel(this.$route.params.model_id)
                .then((res) => {
                    this.ledgers = res
                })
        },
        getPlatformsModel() {
            API.getPlatformsModel(this.$route.params.model_id)
                .then((res) => {
                    this.platforms = res
                })
        },
        getPosition() {
            API.getPositionByModel(this.$route.params.model_id)
                .then((res) => {
                    this.puesto = res.ranking
                })
        }
    },
    beforeMount() {
        this.$root.$emit('changeModel', this.$route.name)
    },
    mounted() {
        this.getMonitor()
        this.getAdministrador()
        this.getMonitorAndAdmin()
        this.getLedgers()
        this.getPlatformsModel()
        this.getPosition()
    }
}
</script>

<style scoped>
    .reporte {
        background-color: #cdcdcd;
        min-height: 78vh;
        height: 78vh;
        padding: 10px;
        display: flex;
    }
    .reporte > div {
        width: 50%;
        height: 100%;
    }
    .reporte > div > .asignaciones {
        width: 100%;
        height: 35%;
        padding: 10px;
    }
    .reporte > div > .asignaciones > div {
        background-color: #63b763;
        border-radius: 20px;
        text-align: center;
        padding: 20px;
        height: 100%;
        color: #fff;
        border-style: outset;
        display: grid;
    }
    .reporte > div > .asignaciones > div > div {
        padding: 10px;
        margin-top: 20px;
        padding: 0px 70px;
    }
    .reporte > div > .asignaciones > div > div > label {
        font-weight: bold;
        font-size: 22px;
        float: left;
    }
    .reporte > div > .asignaciones > div > div > select {
        float: right;
        width: 50%;
        height: 35px;
        text-align: center;
        border-radius: 20px;
    }
    .reporte > div > .ingresos {
        height: 65%;
        width: 100%;
        padding: 10px;
    }
    .reporte > div > .ingresos > div {
        background-color: #8363b7;
        border-radius: 20px;
        text-align: center;
        padding: 20px;
        height: 100%;
        color: #fff;
        border-style: outset;
        overflow-y: auto;
    }
    .reporte > div > .ingresos > div > center > table > thead > tr > th {
        padding: 20px 40px;
        border-style: outset;
    }
    .reporte > div > .ingresos > div > center > table > tbody > tr > td {
        padding: 5px 20px;
        border-style: outset;
    }
    .reporte > div > .plataformas {
        width: 100%;
        height: 50%;
        padding: 10px;
    }
    .reporte > div > .plataformas > div {
        background-color: #b78863;
        height: 100%;
        border-radius: 20px;
        border-style: outset;
        color: #fff;
        text-align: center;
        padding: 10px;
        width: 100%;
    }
    .reporte > div > .plataformas > div > div{
        display: block;
        margin: 20px;
        background-color: #585858;
        border-radius: 20px;
    }
    .reporte > div > .plataformas > div > div > img{
        width: 20%;
    }
    .reporte > div > .plataformas > div > div > label{
        width: 30%;
        padding: 0;
    }
    .reporte > div > .generales {
        width: 100%;
        height: 50%;
        padding: 10px;
    }
    .reporte > div > .generales > div {
        background-color: #63b1b7;
        height: 100%;
        border-radius: 20px;
        border-style: outset;
        color: #fff;
        text-align: center;
        padding: 20px;
        width: 100%;
    }
    .reporte > div > .generales > div > div {
        width: 50%;
        text-align: center;
        float: left;
        height: 80%;
    }
    .reporte > div > .generales > div > div > div{
        height: 50%;
        position: relative;
    }
    .reporte > div > .generales > div > div > div > label{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-weight: bold;
    }
    .reporte > div > .generales > div > div > div > label > span {
        font-size: 24px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Modelos/Reports.vue